import { extend } from 'lodash';
export class LiverampIDRequest {
    ID: number;
    SegmentID: number | null;
    LiverampID: string;
    PartitionName: string;
    ProviderID: number;
    Inserted: string;
    ErrorMessage: string;
    CreatedAt: string;

    public static fromJSON(params: any = {}): LiverampIDRequest {
        return extend(new LiverampIDRequest(), params);
    }
}

export class LiverampProvider {
    ProviderID: number;
    ProviderName: string;

    public static fromJSON(params: any = {}): LiverampProvider {
        return extend(new LiverampProvider(), params);
    }
}
